import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);
export const useCourtyard = () => useContext(Ctx);

const TOKEN_KEY = "ddd_rsvp_token";
const STYLE_KEY = "ddd_style";

function readStyle() {
  try {
    return JSON.parse(localStorage.getItem(STYLE_KEY)) || { mood: null, color: null, rules_accepted: false };
  } catch {
    return { mood: null, color: null, rules_accepted: false };
  }
}

export function CourtyardProvider({ children }) {
  const [event, setEvent] = useState(null);
  const [eventError, setEventError] = useState(false);
  const [rsvp, setRsvp] = useState(null);
  const [rsvpOpen, setRsvpOpen] = useState(false);
  const [style, setStyle] = useState(readStyle);

  useEffect(() => {
    http.get("/event").then((r) => setEvent(r.data)).catch(() => setEventError(true));
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get("rsvp");
    if (fromUrl) {
      localStorage.setItem(TOKEN_KEY, fromUrl);
      url.searchParams.delete("rsvp");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
    const token = fromUrl || localStorage.getItem(TOKEN_KEY);
    if (!token) return;
    http
      .get(`/rsvp/${token}`)
      .then((r) => {
        setRsvp(r.data);
        if (r.data?.mood || r.data?.color || r.data?.rules_accepted) setStyle({ mood: r.data.mood, color: r.data.color, rules_accepted: !!r.data.rules_accepted });
        if (fromUrl) setRsvpOpen(true);
      })
      .catch(() => localStorage.removeItem(TOKEN_KEY));
  }, []);

  const saveRsvp = useCallback((doc) => {
    setRsvp(doc);
    localStorage.setItem(TOKEN_KEY, doc.edit_token);
  }, []);

  const updateStyle = useCallback(
    (patch) => {
      setStyle((s) => {
        const next = { ...s, ...patch };
        localStorage.setItem(STYLE_KEY, JSON.stringify(next));
        return next;
      });
      if (rsvp?.edit_token) {
        const body = Object.fromEntries(Object.entries(patch).map(([k, v]) => [k, typeof v === "boolean" ? v : v || ""]));
        http.patch(`/rsvp/${rsvp.edit_token}/style`, body).then((r) => setRsvp(r.data)).catch(() => {});
      }
    },
    [rsvp?.edit_token]
  );

  const value = { event, eventError, rsvp, saveRsvp, rsvpOpen, openRsvp: () => setRsvpOpen(true), setRsvpOpen, style, updateStyle };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
